// this file is automatically generated by git.version.ts script
export const versions = {
  version: '11.0.0',
  revision: 'NO_REV',
  branch: 'NO_BRANCH',
};
